import { Provider, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  provideTransloco,
  provideTranslocoScope,
  TranslocoModule,
} from '@jsverse/transloco';
import { CrewTranslocoHttpLoader } from './crew-transloco-http-loader';

export interface CrewTranslocoConfig {
  /** Default language code. Defaults to 'no'. */
  defaultLang?: string;
  /** Available language codes. Defaults to ['no', 'en', 'sv', 'da']. */
  availableLangs?: Array<string>;
  /** Whether to enable production mode (turns off missing key warnings). */
  prodMode?: boolean;
}

/**
 * Provides Transloco configuration for Crew applications.
 * Call this in your app's providers array (app.config.ts or AppModule).
 *
 * @example
 * ```ts
 * provideCrewTransloco({ prodMode: environment.production })
 * ```
 */
export function provideCrewTransloco(config?: CrewTranslocoConfig): EnvironmentProviders {
  const defaultLang: string = config?.defaultLang ?? 'no';
  const availableLangs: Array<string> = config?.availableLangs ?? ['no', 'en', 'sv', 'da'];
  const prodMode: boolean = config?.prodMode ?? false;

  return makeEnvironmentProviders([
    provideTransloco({
      config: {
        availableLangs,
        defaultLang,
        reRenderOnLangChange: true,
        prodMode,
        missingHandler: {
          useFallbackTranslation: true,
        },
        fallbackLang: 'no',
      },
      loader: CrewTranslocoHttpLoader,
    }),
    provideTranslocoScope({ scope: 'common', alias: 'COMMON' }),
  ]);
}
